var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    staticClass: "soli-round soli-grey",
    attrs: {
      "prepend-inner-icon": "verified_user",
      outlined: "",
      dense: "",
      value: _vm.value,
      "menu-props": "auto",
      items: _vm.certifications,
      label: "Certification Level",
      disabled: _vm.disabled,
      color: "error",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "append",
        fn: function () {
          return [
            _vm.alert
              ? _c("v-icon", { attrs: { color: "error" } }, [
                  _vm._v("error_outline"),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }